"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useSectionItem = void 0;
var BasketUpdated = _interopRequireWildcard(require("@ori-events/basket-updated"));
var _openBackInStockNotificationDialog = require("@ori-events/open-back-in-stock-notification-dialog");
var SubscriptionSaved = _interopRequireWildcard(require("@ori-events/subscription-saved"));
var _react = require("react");
var _api = require("../../api");
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _logger = require("../../logger");
var _types = require("../../types");
var _utils = require("../../utils");
var _useBackorderDelayCancel = require("./useBackorderDelayCancel");
var _useButtons = require("./useButtons");
var _useControlledQuantityPicker = require("./useControlledQuantityPicker");
var _useDialog = require("./useDialog");
var _useRemoveHandler = require("./useRemoveHandler");
var _useSubscriptionHandlers = require("./useSubscriptionHandlers");
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
const useSectionItem = (props)=>{
    const { item, mapperProps, actionsProps } = props;
    const { atpClusterId, basketItemTranslations, basketItemTranslationsNamespace, isConsultant, isDiscounted, showBpGlobally, splitoutItemsMap } = (0, _contexts.useBasketContext)();
    const { formatMessage } = (0, _hooks.useTranslations)();
    const { isBackorderExplicit, isSimplifiedCheckout } = (0, _contexts.useCheckoutBasket)();
    const [initialQuantity, setInitialQuantity] = (0, _react.useState)(-1);
    const { backorderDemandStatus, canBeDeleted, canBeNotified, canBeReduced, canDelayBackorder, droppingId, isAvailable, isBackorderAllowed, isSubscriptionReplacementAllowed, itemCode, itemType, itemDescription, lineNumber, maxQuantity, quantity, showOnSite, replacement, requestedQuantity, subscription } = item;
    const { combineChoiceId, endConsumerOrderId, isShippingOfferItem, offerChoiceId, placement, subscriptionId, subscriptionItemInfo, handleChangedLineNumber, handleFeedbackOpen } = actionsProps;
    const { isPersonalSubscriptionAvailable } = (0, _api.usePersonalSubscriptionAvailability)(itemCode, itemType);
    const { onSubscribeClick, onSubscriptionSaved } = (0, _useSubscriptionHandlers.useSubscriptionHandlers)({
        itemCode,
        lineNumber,
        originalQuantity: quantity,
        placement,
        quantity,
        requestedQuantity
    });
    const [changedLineNumber, setChangedLineNumber] = (0, _react.useState)(null);
    const splitoutData = (0, _react.useMemo)(()=>{
        if (!splitoutItemsMap || splitoutItemsMap.length === 0) {
            return undefined;
        }
        return splitoutItemsMap.find((x)=>x.itemCode === itemCode);
    }, [
        itemCode,
        splitoutItemsMap
    ]);
    (0, _logger.logDebug)("".concat(lineNumber, "-").concat(itemCode, " -> useSectionItem"));
    // stuff that trigger dialog ... replace and reserve
    const { canBeReplaced, addBackorderDemand, showReplacementDialog } = (0, _useDialog.useDialog)({
        atpClusterId,
        droppingId,
        isSubscriptionReplacementAllowed,
        itemCode,
        lineNumber,
        quantity,
        replacement,
        subscriptionId,
        subscriptionItemInfo,
        handleChangedLineNumber,
        setChangedLineNumber
    });
    const checkItemChange = (0, _react.useCallback)((data)=>{
        if (changedLineNumber !== null) {
            data.detail.shoppingBag.shoppingBagItems.forEach((x)=>{
                if (x.lineNumber === changedLineNumber && x.backorderDemandStatus === 2) {
                    if (handleFeedbackOpen) {
                        handleFeedbackOpen(_types.FeedbackNotificationType.Reserve);
                    }
                    setChangedLineNumber(null);
                }
            });
        }
    }, [
        changedLineNumber,
        handleFeedbackOpen,
        setChangedLineNumber
    ]);
    const handleItemChange = (0, _react.useCallback)((data)=>{
        checkItemChange(data);
    }, [
        checkItemChange
    ]);
    // delete button
    const { removeItemHandler } = (0, _useRemoveHandler.useRemoveHandler)({
        endConsumerOrderId,
        isShippingOfferItem,
        itemCode,
        itemType,
        lineNumber,
        offerChoiceId,
        outOfStock: requestedQuantity > quantity,
        placement,
        requestedQuantity,
        handleChangedLineNumber,
        setChangedLineNumber
    });
    // notify me
    const showNotificationDialog = (0, _react.useCallback)(()=>{
        const event = new CustomEvent(_openBackInStockNotificationDialog.Name, {
            detail: {
                code: itemCode
            }
        });
        window.dispatchEvent(event);
    }, [
        itemCode
    ]);
    // backorder delay and cancel
    const { onCancelBackorderDemand, onDelayBackorder } = (0, _useBackorderDelayCancel.useBackorderDelayCancel)({
        itemCode,
        lineNumber,
        placement,
        quantity,
        requestedQuantity,
        handleFeedbackOpen
    });
    var _mapperProps_isSubscription;
    // buttons
    const buttons = (0, _useButtons.useButtons)({
        addBackorderDemand,
        backorderDemandStatus,
        canBeDeleted,
        canBeNotified,
        canBeReplaced,
        canDelayBackorder,
        combineChoiceId,
        isAvailable,
        isBackorderAllowed,
        isBackorderExplicit,
        isPersonalSubscriptionAvailable,
        isSubscription: (_mapperProps_isSubscription = mapperProps.isSubscription) !== null && _mapperProps_isSubscription !== void 0 ? _mapperProps_isSubscription : false,
        itemDescription,
        itemType,
        onCancelBackorderDemand,
        onDelayBackorder,
        onSubscribeClick,
        removeItemHandler,
        replacement,
        showOnSite,
        showNotificationDialog,
        showReplacementDialog,
        subscription
    });
    // quantity stuff
    const { onQuantityChange } = (0, _useControlledQuantityPicker.useControlledQuantityPicker)({
        canBeDeleted,
        canBeReduced,
        endConsumerOrderId,
        initialQuantity,
        itemCode,
        lineNumber,
        maxQuantity,
        quantity,
        placement,
        removeItemHandler
    });
    (0, _react.useEffect)(()=>{
        if (isBackorderAllowed && changedLineNumber !== null) {
            window.addEventListener(BasketUpdated.Name, handleItemChange);
        } else {
            window.removeEventListener(BasketUpdated.Name, handleItemChange);
        }
        return ()=>{
            window.removeEventListener(BasketUpdated.Name, handleItemChange);
        };
    }, [
        changedLineNumber,
        handleItemChange,
        isBackorderAllowed
    ]);
    (0, _react.useEffect)(()=>{
        const subscriptionSavedHandler = async ()=>{
            await onSubscriptionSaved();
        };
        window.addEventListener(SubscriptionSaved.eventName, subscriptionSavedHandler);
        return ()=>window.removeEventListener(SubscriptionSaved.eventName, subscriptionSavedHandler);
    }, [
        onSubscriptionSaved
    ]);
    (0, _react.useEffect)(()=>{
        setInitialQuantity((prev)=>prev === -1 ? quantity : prev);
    }, [
        quantity
    ]);
    // map item to basket item
    const basketItem = (0, _react.useMemo)(()=>{
        const { personalSubscription } = item;
        const data = (0, _utils.mapShoppingBagItem)({
            item,
            commonProps: {
                ...mapperProps,
                infoAddon: personalSubscription ? formatMessage('everyXweeks', {
                    frequency: personalSubscription.frequency / 7
                }) : undefined,
                isBrandPartner: isConsultant,
                isDiscounted,
                isWithoutSummary: !isSimplifiedCheckout,
                showBpGlobally,
                basketItemTranslations,
                basketItemTranslationsNamespace,
                initialQuantity
            }
        });
        const { bundles } = item;
        const itemBundle = bundles !== null && bundles !== void 0 ? bundles : [];
        if (!mapperProps.isBundleItem && itemBundle.length > 0) {
            data.bundleItems = itemBundle.map((bundleItem)=>(0, _utils.mapShoppingBagItem)({
                    item: bundleItem,
                    commonProps: {
                        ...mapperProps,
                        isBundleItem: true,
                        showBpGlobally,
                        basketItemTranslations,
                        basketItemTranslationsNamespace,
                        initialQuantity: 1
                    }
                }));
        }
        data.requestedQuantitySplitout = item.lineNumber === (splitoutData === null || splitoutData === void 0 ? void 0 : splitoutData.parentLineNumber) ? splitoutData.splitoutRequestedQuantity : undefined;
        data.buttons = buttons;
        data.onQuantityChange = onQuantityChange;
        return data;
    }, [
        basketItemTranslations,
        basketItemTranslationsNamespace,
        buttons,
        formatMessage,
        initialQuantity,
        isConsultant,
        isDiscounted,
        isSimplifiedCheckout,
        item,
        mapperProps,
        onQuantityChange,
        showBpGlobally,
        splitoutData
    ]);
    return {
        basketItem,
        splitoutData
    };
};
exports.useSectionItem = useSectionItem;
